import React from 'react'
import Icon from './icons'

type ModalCloseIconButtonProps = {
    onClick?: () => void
    className?: string
    ariaLabel?: string
}

const ModalCloseIconButton: React.FC<ModalCloseIconButtonProps> = ({ onClick, className = '', ariaLabel = 'Close modal' }) => {
    return (
        <button
            aria-label={ariaLabel}
            type="button"
            className={`absolute z-50 right-2 top-2 text-black outline-none bg-transparent rounded-full h-5 w-5 flex justify-center items-center flex-end transition-all duration-200 hover:bg-gray-200 ${className}`}
            onClick={onClick}
        >
            <Icon name="close" size={'1rem'} />
        </button>
    )
}

export default ModalCloseIconButton
